export default __webpack_public_path__ + "static/media/airco.0e6c5dda.jpg";